import { findMessage } from '../../..';

const deMessages = {
	de: {
		Yes: 'Ja',
		No: 'Nein',
		Cancel: 'Abbrechen',
		Clear: 'Löschen',
		Done: 'Fertig',
		Loading: 'Wird geladen...',
		Select: 'Auswählen...',
		Search: 'Suchen',
		Back: 'Zurück',
		OK: 'OK',
		'dxCollectionWidget-noDataText': 'Keine Daten zum Anzeigen',
		'validation-required': 'Erforderlich',
		'validation-required-formatted': '{0} erforderlich',
		'validation-numeric': 'Wert muss eine Zahl sein',
		'validation-numeric-formatted': '{0} muss eine Zahl sein',
		'validation-range': 'Wert liegt außerhalb des Bereichs',
		'validation-range-formatted': '{0} liegt außerhalb des Bereichs',
		'validation-stringLength': 'Die Länge des Werts ist nicht korrekt',
		'validation-stringLength-formatted': '{0} Länge ist nicht korrekt',
		'validation-custom': 'Wert ist ungültig',
		'validation-custom-formatted': '{0} ist ungültig',
		'validation-compare': 'Werte stimmen nicht überein',
		'validation-compare-formatted': '{0} stimmt nicht überein',
		'validation-pattern': 'Wert entspricht nicht dem Muster',
		'validation-pattern-formatted': '{0} entspricht nicht dem Muster',
		'validation-email': 'E-Mail ist ungültig',
		'validation-email-formatted': '{0} ist ungültig',
		'validation-mask': 'Wert ist ungültig',
		'dxLookup-searchPlaceholder': 'Mindestanzahl der Zeichen: {0}',
		'dxList-pullingDownText': 'Zum Aktualisieren nach unten ziehen...',
		'dxList-pulledDownText': 'Zum Aktualisieren loslassen...',
		'dxList-refreshingText': 'Wird aktualisiert...',
		'dxList-pageLoadingText': 'Wird geladen...',
		'dxList-nextButtonText': 'Mehr',
		'dxList-selectAll': 'Alle auswählen',
		'dxListEditDecorator-delete': 'Löschen',
		'dxListEditDecorator-more': 'Mehr',
		'dxScrollView-pullingDownText': 'Zum Aktualisieren nach unten ziehen...',
		'dxScrollView-pulledDownText': 'Zum Aktualisieren loslassen...',
		'dxScrollView-refreshingText': 'Wird aktualisiert...',
		'dxScrollView-reachBottomText': 'Wird geladen...',
		'dxDateBox-simulatedDataPickerTitleTime': 'Zeit auswählen',
		'dxDateBox-simulatedDataPickerTitleDate': 'Datum auswählen',
		'dxDateBox-simulatedDataPickerTitleDateTime': 'Datum und Uhrzeit auswählen',
		'dxDateBox-validation-datetime': 'Wert muss ein Datum oder eine Uhrzeit sein',
		'dxFileUploader-selectFile': 'Datei auswählen',
		'dxFileUploader-dropFile': 'oder Datei hier ablegen',
		'dxFileUploader-bytes': 'Bytes',
		'dxFileUploader-kb': 'KB',
		'dxFileUploader-Mb': 'MB',
		'dxFileUploader-Gb': 'GB',
		'dxFileUploader-upload': 'Hochladen',
		'dxFileUploader-uploaded': 'Hochgeladen',
		'dxFileUploader-readyToUpload': 'Bereit zum Hochladen',
		'dxFileUploader-uploadAbortedMessage': 'Hochladen abgebrochen',
		'dxFileUploader-uploadFailedMessage': 'Hochladen fehlgeschlagen',
		'dxFileUploader-invalidFileExtension': 'Dateityp nicht erlaubt',
		'dxFileUploader-invalidMaxFileSize': 'Datei zu groß',
		'dxFileUploader-invalidMinFileSize': 'Datei zu klein',
		'dxRangeSlider-ariaFrom': 'Von',
		'dxRangeSlider-ariaTill': 'Bis',
		'dxSwitch-switchedOnText': 'Ein',
		'dxSwitch-switchedOffText': 'Aus',
		'dxForm-optionalMark': 'optional',
		'dxForm-requiredMessage': '{0} erforderlich',
		'dxNumberBox-invalidValueMessage': 'Wert muss eine Zahl sein',
		'dxNumberBox-noDataText': 'Keine Daten',
		'dxDataGrid-columnChooserTitle': 'Spaltenauswahl',
		'dxDataGrid-columnChooserEmptyText': 'Ziehen Sie eine Spalte hierher, um sie auszublenden',
		'dxDataGrid-groupContinuesMessage': 'Fährt auf der nächsten Seite fort',
		'dxDataGrid-groupContinuedMessage': 'Fortsetzung auf der vorherigen Seite',
		'dxDataGrid-groupHeaderText': 'Nach dieser Spalte gruppieren',
		'dxDataGrid-ungroupHeaderText': 'Gruppe aufheben',
		'dxDataGrid-ungroupAllText': 'Alle Gruppen aufheben',
		'dxDataGrid-editingEditRow': 'Bearbeiten',
		'dxDataGrid-editingSaveRowChanges': 'Speichern',
		'dxDataGrid-editingCancelRowChanges': 'Abbrechen',
		'dxDataGrid-editingDeleteRow': 'Löschen',
		'dxDataGrid-editingUndeleteRow': 'Wiederherstellen',
		'dxDataGrid-editingConfirmDeleteMessage':
			'Sind Sie sicher, dass Sie diesen Datensatz löschen möchten?',
		'dxDataGrid-validationCancelChanges': 'Änderungen abbrechen',
		'dxDataGrid-groupPanelEmptyText':
			'Ziehen Sie eine Spaltenüberschrift hierher, um nach dieser Spalte zu gruppieren',
		'dxDataGrid-noDataText': 'Keine Daten',
		'dxDataGrid-searchPanelPlaceholder': 'Suche...',
		'dxDataGrid-filterRowShowAllText': '(Alle)',
		'dxDataGrid-filterRowResetOperationText': findMessage.get('100888'),
		'dxDataGrid-filterRowOperationEquals': findMessage.get('101711'),
		'dxDataGrid-filterRowOperationNotEquals': findMessage.get('101712'),
		'dxDataGrid-filterRowOperationLess': findMessage.get('101715'),
		'dxDataGrid-filterRowOperationLessOrEquals': findMessage.get('101716'),
		'dxDataGrid-filterRowOperationGreater': findMessage.get('101713'),
		'dxDataGrid-filterRowOperationGreaterOrEquals': findMessage.get('101714'),
		'dxDataGrid-filterRowOperationStartsWith': findMessage.get('101720'),
		'dxDataGrid-filterRowOperationContains': findMessage.get('101718'),
		'dxDataGrid-filterRowOperationNotContains': findMessage.get('101719'),
		'dxDataGrid-filterRowOperationEndsWith': findMessage.get('101721'),
		'dxDataGrid-filterRowOperationBetween': 'Zwischen',
		'dxDataGrid-filterRowOperationBetweenStartText': 'Start',
		'dxDataGrid-filterRowOperationBetweenEndText': 'Ende',
		'dxDataGrid-applyFilterText': 'Filter anwenden',
		'dxDataGrid-trueText': 'Ja',
		'dxDataGrid-falseText': 'Nein',
		'dxDataGrid-sortingAscendingText': findMessage.get('101723'),
		'dxDataGrid-sortingDescendingText': findMessage.get('101724'),
		'dxDataGrid-sortingClearText': 'Sortierung zurücksetzen',
		'dxDataGrid-editingSaveAllChanges': 'Alle Änderungen speichern',
		'dxDataGrid-editingCancelAllChanges': 'Alle Änderungen abbrechen',
		'dxDataGrid-editingAddRow': 'Zeile hinzufügen',
		'dxDataGrid-summaryMin': 'Min: {0}',
		'dxDataGrid-summaryMinOtherColumn': '{1} min: {0}',
		'dxDataGrid-summaryMax': 'Max: {0}',
		'dxDataGrid-summaryMaxOtherColumn': '{1} max: {0}',
		'dxDataGrid-summaryAvg': 'Durchschnitt: {0}',
		'dxDataGrid-summaryAvgOtherColumn': '{1} Durchschnitt: {0}',
		'dxDataGrid-summarySum': 'Summe: {0}',
		'dxDataGrid-summarySumOtherColumn': '{1} Summe: {0}',
		'dxDataGrid-summaryCount': 'Gesamt: {0}',
		'dxDataGrid-columnFixingFix': 'Fixieren',
		'dxDataGrid-columnFixingUnfix': 'Lösen',
		'dxDataGrid-columnFixingLeftPosition': 'Links',
		'dxDataGrid-columnFixingRightPosition': 'Rechts',
		'dxDataGrid-exportTo': 'Exportieren',
		'dxDataGrid-exportToExcel': 'In Excel-Datei exportieren',
		'dxDataGrid-exporting': 'Exportieren...',
		'dxDataGrid-excelFormat': 'Excel-Datei',
		'dxDataGrid-selectedRows': 'Ausgewählte Zeilen',
		'dxDataGrid-exportSelectedRows': 'Ausgewählte Zeilen exportieren',
		'dxDataGrid-exportAll': 'Alle Daten exportieren',
		'dxDataGrid-headerFilterEmptyValue': '(Leere Werte)',
		'dxDataGrid-headerFilterOK': 'OK',
		'dxDataGrid-headerFilterCancel': 'Abbrechen',
		'dxDataGrid-ariaColumn': 'Spalte',
		'dxDataGrid-ariaValue': 'Wert',
		'dxDataGrid-ariaFilterCell': 'Filterzelle',
		'dxDataGrid-ariaCollapse': 'Einklappen',
		'dxDataGrid-ariaExpand': 'Ausklappen',
		'dxDataGrid-ariaDataGrid': 'Tabelle',
		'dxDataGrid-ariaSearchInGrid': 'In der Tabelle suchen',
		'dxDataGrid-ariaSelectAll': 'Alle auswählen',
		'dxDataGrid-ariaSelectRow': 'Zeile auswählen',
		'dxDataGrid-filterBuilderPopupTitle': 'Filter Builder',
		'dxDataGrid-filterPanelCreateFilter': 'Filter erstellen',
		'dxDataGrid-filterPanelClearFilter': 'Zurücksetzen',
		'dxDataGrid-filterPanelFilterEnabledHint': 'Filter aktivieren',
		'dxTreeList-ariaTreeList': 'Baum-Liste',
		'dxTreeList-editingAddRowToNode': 'Hinzufügen',
		'dxPager-infoText': 'Seite {0} / {1} ({2} Daten)',
		'dxPager-pagesCountText': 'von',
		'dxPager-pageSizesAllText': 'Alle',
		'dxPivotGrid-grandTotal': 'Gesamtsumme',
		'dxPivotGrid-total': '{0} Gesamt',
		'dxPivotGrid-fieldChooserTitle': 'Feldwähler',
		'dxPivotGrid-showFieldChooser': 'Feldwähler anzeigen',
		'dxPivotGrid-expandAll': 'Alle erweitern',
		'dxPivotGrid-collapseAll': 'Alle einklappen',
		'dxPivotGrid-sortColumnBySummary': 'Nach "{0}" in dieser Spalte sortieren',
		'dxPivotGrid-sortRowBySummary': 'Nach "{0}" in dieser Zeile sortieren',
		'dxPivotGrid-removeAllSorting': 'Alle Sortierungen entfernen',
		'dxPivotGrid-dataNotAvailable': 'N/A',
		'dxPivotGrid-rowFields': 'Zeilenfelder',
		'dxPivotGrid-columnFields': 'Spaltenfelder',
		'dxPivotGrid-dataFields': 'Datenfelder',
		'dxPivotGrid-filterFields': 'Filterfelder',
		'dxPivotGrid-allFields': 'Alle Felder',
		'dxPivotGrid-columnFieldArea': 'Spaltenfelder hier ablegen',
		'dxPivotGrid-dataFieldArea': 'Datenfelder hier ablegen',
		'dxPivotGrid-rowFieldArea': 'Zeilenfelder hier ablegen',
		'dxPivotGrid-filterFieldArea': 'Filterfelder hier ablegen',
		'dxScheduler-editorLabelTitle': 'Betreff',
		'dxScheduler-editorLabelStartDate': 'Startdatum',
		'dxScheduler-editorLabelEndDate': 'Enddatum',
		'dxScheduler-editorLabelDescription': 'Beschreibung',
		'dxScheduler-editorLabelRecurrence': 'Wiederholung',
		'dxScheduler-openAppointment': 'Termin öffnen',
		'dxScheduler-recurrenceNever': 'Nie',
		'dxScheduler-recurrenceMinutely': 'Minütlich',
		'dxScheduler-recurrenceHourly': 'Stündlich',
		'dxScheduler-recurrenceDaily': 'Täglich',
		'dxScheduler-recurrenceWeekly': 'Wöchentlich',
		'dxScheduler-recurrenceMonthly': 'Monatlich',
		'dxScheduler-recurrenceYearly': 'Jährlich',
		'dxScheduler-recurrenceRepeatEvery': 'Jedes Mal wiederholen',
		'dxScheduler-recurrenceRepeatOn': 'Wiederholen',
		'dxScheduler-recurrenceEnd': 'Wiederholung beenden',
		'dxScheduler-recurrenceAfter': 'Nach',
		'dxScheduler-recurrenceOn': 'Am',
		'dxScheduler-recurrenceRepeatMinutely': 'Minute(n)',
		'dxScheduler-recurrenceRepeatHourly': 'Stunde(n)',
		'dxScheduler-recurrenceRepeatDaily': 'Tag(e)',
		'dxScheduler-recurrenceRepeatWeekly': 'Woche(n)',
		'dxScheduler-recurrenceRepeatMonthly': 'Monat(e)',
		'dxScheduler-recurrenceRepeatYearly': 'Jahr(e)',
		'dxScheduler-switcherDay': 'Tag',
		'dxScheduler-switcherWeek': 'Woche',
		'dxScheduler-switcherWorkWeek': 'Arbeitswoche',
		'dxScheduler-switcherMonth': 'Monat',
		'dxScheduler-switcherAgenda': 'Agenda',
		'dxScheduler-switcherTimelineDay': 'Zeitachse Tag',
		'dxScheduler-switcherTimelineWeek': 'Zeitachse Woche',
		'dxScheduler-switcherTimelineWorkWeek': 'Zeitachse Arbeitswoche',
		'dxScheduler-switcherTimelineMonth': 'Zeitachse Monat',
		'dxScheduler-recurrenceRepeatOnDate': 'am',
		'dxScheduler-recurrenceRepeatCount': 'Ereignisse',
		'dxScheduler-allDay': 'Ganztägig',
		'dxScheduler-confirmRecurrenceEditMessage':
			'Möchten Sie nur diesen Termin oder die gesamte Serie bearbeiten?',
		'dxScheduler-confirmRecurrenceDeleteMessage':
			'Möchten Sie nur diesen Termin oder die gesamte Serie löschen?',
		'dxScheduler-confirmRecurrenceEditSeries': 'Serie bearbeiten',
		'dxScheduler-confirmRecurrenceDeleteSeries': 'Serie löschen',
		'dxScheduler-confirmRecurrenceEditOccurrence': 'Termin bearbeiten',
		'dxScheduler-confirmRecurrenceDeleteOccurrence': 'Termin löschen',
		'dxScheduler-noTimezoneTitle': 'Keine Zeitzone',
		'dxScheduler-moreAppointments': '{0} weitere',
		'dxCalendar-todayButtonText': 'Heute',
		'dxCalendar-ariaWidgetName': 'Kalender',
		'dxColorView-ariaRed': 'Rot',
		'dxColorView-ariaGreen': 'Grün',
		'dxColorView-ariaBlue': 'Blau',
		'dxColorView-ariaAlpha': 'Transparenz',
		'dxColorView-ariaHex': 'Farbcode',
		'dxTagBox-selected': '{0} ausgewählt',
		'dxTagBox-allSelected': 'Alle ausgewählt ({0})',
		'dxTagBox-moreSelected': '{0} weitere',
		'vizExport-printingButtonText': 'Drucken',
		'vizExport-titleMenuText': 'Exportieren/Drucken',
		'vizExport-exportButtonText': '{0} Datei',
		'dxFilterBuilder-and': 'Und',
		'dxFilterBuilder-or': 'Oder',
		'dxFilterBuilder-notAnd': 'Nicht Und',
		'dxFilterBuilder-notOr': 'Nicht Oder',
		'dxFilterBuilder-addCondition': 'Bedingung hinzufügen',
		'dxFilterBuilder-addGroup': 'Gruppe hinzufügen',
		'dxFilterBuilder-enterValueText': '<Wert eingeben>',
		'dxFilterBuilder-filterOperationEquals': 'Gleich',
		'dxFilterBuilder-filterOperationNotEquals': 'Ungleich',
		'dxFilterBuilder-filterOperationLess': 'Weniger',
		'dxFilterBuilder-filterOperationLessOrEquals': 'Weniger oder gleich',
		'dxFilterBuilder-filterOperationGreater': 'Mehr',
		'dxFilterBuilder-filterOperationGreaterOrEquals': 'Mehr oder gleich',
		'dxFilterBuilder-filterOperationStartsWith': 'Beginnt mit',
		'dxFilterBuilder-filterOperationContains': 'Enthält',
		'dxFilterBuilder-filterOperationNotContains': 'Enthält nicht',
		'dxFilterBuilder-filterOperationEndsWith': 'Endet mit',
		'dxFilterBuilder-filterOperationIsBlank': 'Leer',
		'dxFilterBuilder-filterOperationIsNotBlank': 'Nicht leer',
		'dxFilterBuilder-filterOperationBetween': 'Zwischen',
		'dxFilterBuilder-filterOperationAnyOf': 'Irgendeiner',
		'dxFilterBuilder-filterOperationNoneOf': 'Keiner',
		'dxHtmlEditor-dialogColorCaption': 'Schriftfarbe ändern',
		'dxHtmlEditor-dialogBackgroundCaption': 'Hintergrundfarbe ändern',
		'dxHtmlEditor-dialogLinkCaption': 'Link hinzufügen',
		'dxHtmlEditor-dialogLinkUrlField': 'URL',
		'dxHtmlEditor-dialogLinkTextField': 'Text',
		'dxHtmlEditor-dialogLinkTargetField': 'Link in neuem Fenster öffnen',
		'dxHtmlEditor-dialogImageCaption': 'Bild hinzufügen',
		'dxHtmlEditor-dialogImageUrlField': 'URL',
		'dxHtmlEditor-dialogImageAltField': 'Alternativtext',
		'dxHtmlEditor-dialogImageWidthField': 'Breite (px)',
		'dxHtmlEditor-dialogImageHeightField': 'Höhe (px)',
		'dxHtmlEditor-dialogInsertTableRowsField': '!TODO',
		'dxHtmlEditor-dialogInsertTableColumnsField': '!TODO',
		'dxHtmlEditor-dialogInsertTableCaption': '!TODO',
		'dxHtmlEditor-heading': 'Überschrift',
		'dxHtmlEditor-normalText': 'Normaler Text'
	}
};

export default deMessages;
